import React from "react";

import aboutImg from "../images/about.jpeg"; // Replace with your image

const AboutUs = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-content">
        <div className="about-text">
          <h2>About Us</h2>
          <p>
             <strong>Sevendays by Ideal Foods</strong>
         is more than just a bakery — it’s a destination for flavor lovers. Born from the trusted name of Ideal Foods, our vision was simple: to create a space where people can enjoy a wide variety of freshly made savory and sweet delights, any day of the week.
          </p>
          <p>
       We take pride in offering something for everyone. From our signature stuffed rolls, pizzas, burgers, and sandwiches to indulgent pastries, dry cakes, traditional bakes, and custom cakes, our menu is crafted to bring together quality, taste, and comfort in every bite.
          </p>
          <p>
     Everything we serve is made with care — from sourcing fresh ingredients to baking daily in-house. Whether you're here for a casual bite, a celebration treat, or a fun combo meal with friends, we aim to make your experience satisfying and memorable.
          </p>
          <p>
    At Sevendays, we believe good food brings people together. And we're here to make that happen — one bite, one smile, and one visit at a time.
          </p>
        </div>
        <div className="about-image">
          <img src={aboutImg} alt="Bakery" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
